const urlParams = {
  HIDE_MOBILE_OUTLINE: {
    KEY: 'hideMobileOutline',
    VALUES: {
      TRUE: 'true',
      FALSE: 'false',
    },
  },
}

export default urlParams
